module.exports = __webpack_public_path__ + "img/cover_deskStationery.a3b5e944.jpg";